import { Box } from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

type Props = {
  name: string;
  index: number;
  showIndex?: boolean;
};

function CarrierTableRow({
  name,
  index,
  showIndex = true,
}: Props): JSX.Element {
  return (
    <Box
      display="flex"
      sx={{
        borderTop: 1,
        borderBottom: 1,
        borderColor: "grey.300",
        bgcolor: "grey.300",
      }}
    >
      {showIndex ? (
        <Typography variant="body-medium" width="30%" p={2}>
          {index + 1}
        </Typography>
      ) : null}
      <Typography variant="body-medium" width="70%" p={2}>
        {name}
      </Typography>
    </Box>
  );
}

export default CarrierTableRow;
